module.exports = __webpack_public_path__ + "media/assets/icons/thumb-tack-icon-purple-82cd915c05c0cb58daa5daf70bcfd543.png";